import styled from 'styled-components'
import { ButtonStyleType } from 'src/types/type'
import { Mkt04responsiveWidth } from '.'

const JoinSubmitWrap = styled.div`
  ${Mkt04responsiveWidth};
  position: relative;
  z-index:2;
  box-sizing: border-box;
  padding: 0 16px 30px;
  margin: 0 auto;
`
const CustomBtn = styled.button<ButtonStyleType>`
  cursor: pointer;
  display: block;
  border: none;
  outline: none;
  width: ${(props) => (props.width ? props.width : '100%')};
  margin: 0 0 8px 0;
  padding: 0 16px;
  background-color: ${(props) => props.backgroundColor};
  font-size: ${(props) => props.fontSize};
  font-family: ${(props) => props.fontFamily};
  color: ${(props) => props.fontColor ?? '#fff'};
  font-weight: ${(props) => props.fontWeight ?? 0};
  letter-spacing: ${(props) => props.letterSpacing};
  height: ${(props) => (props.height ? props.height : '48px')};
  border-radius: 12px;

  -webkit-tap-highlight-color: transparent;
  
  > span,
  > a {
    text-align: center;
    color: ${(props) => (props.color ? props.color : '#FFF')};
    line-height: ${(props) => (props.height ? props.height : '18px')};
    font-family: ${({ theme }) => theme.fontFamily};
    font-size: ${(props) => (props.fontSize ? props.fontSize : '12px')};
  }

  &:active {
    background-color: #D13B3B;
  }
  &.btn_cancel:active {
    background-color: #F5F5F5;
  }
`

const NoticeWrap = styled.div`
  ${Mkt04responsiveWidth};
  box-sizing: border-box;
  padding: 16px 10px;
  margin: 0 auto;  
  border-top: 1px solid #e7e8ed;
`
const NoticeText = styled.p<{fontSize: string; cashSpace: string }>`
  margin: 0 auto;
  text-align: left;
  color:#484B52;
  font-family: ${({ theme }) => theme.fontFamily};
  /* font-size: ${(props) => (props.fontSize ? props.fontSize : '12px')}; */
  font-size: 14px;
  line-height: 1.6;
  letter-spacing: ${(props) => (props.cashSpace ? props.cashSpace : '-0.02rem')};
  display: inline-flex;
  flex-flow: row nowrap;
  gap: 6px;
  &::before{
    content: '·';
    display: inline-block;
  }
  font-weight: 700;
`

const NoticeFeeText = styled.p<{ fontColor: string; fontSize: string; cashSpace: string }>`
  margin: 0 auto;
  text-align: left;
  /* color:${(props) => (props.fontColor ? props.fontColor : '#717580')}; */
  color: #F3223C;
  font-family: ${({ theme }) => theme.fontFamily};
  /* font-size: ${(props) => (props.fontSize ? props.fontSize : '12px')}; */
  font-size: 14px;
  line-height: 1.6;
  letter-spacing: ${(props) => (props.cashSpace ? props.cashSpace : '-0.02rem')};
  display: inline-flex;
  flex-flow: row nowrap;
  gap: 6px;
  &::before{
    content: '·';
    display: inline-block;
    color:${(props) => (props.fontColor ? props.fontColor : '#F3223C')};
  }
  font-weight: 700;
`


export { JoinSubmitWrap, CustomBtn,NoticeText, NoticeFeeText, NoticeWrap }
